import React from 'react';
import { Field, Form, reduxForm, getFormValues } from 'redux-form';
import TextArea from '../../TextArea';
import { Col, FormGroup, Row } from 'react-bootstrap';
import HorizontalFormControl from '../../../../../common/components/HorizontalFormControl/HorizontalFormControl';
import ControlLabel from 'react-bootstrap/es/ControlLabel';
import Button from '../../../../../common/components/Button/Button';
import InfoLabel from '../../../../../common/components/InfoLabel/InfoLabel';
import Icon from '../../../../../common/components/Icon/Icon';
import { actions } from '../../../redux/contentActions';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class MetaInfoItem extends React.Component {
  state = {
    showField: false,
    enableEditing: false,
    saving: false,
  };

  componentWillMount() {
    const { dispatch, change, item, fieldKey } = this.props;
    dispatch(change(`${fieldKey}.data.id`, item.id));
    dispatch(change(`${fieldKey}.data.attributes.sections`, item.attributes.sections));
  }

  toggleShowField = () => {
    this.setState((prevState) => ({
      showField: !prevState.showField,
      enableEditing: false,
    }));
  };

  handleEditDefinition = () => {
    this.setState({
      enableEditing: true,
    });
  };

  handleSaveChanges = (formValues) => {
    const { fieldKey, item, actions } = this.props;
    this.setState({
      saving: true,
    });
    const resource = {
      data: formValues[fieldKey].data,
    };
    actions.updateMetaInfo(resource, item.id);
  };

  handleCancelEditing = () => {
    const { dispatch, item, change } = this.props;
    dispatch(change('metaInfo', item));
    this.setState({
      enableEditing: false,
    });
  };

  renderFields = () => {
    const { handleSubmit, fieldKey } = this.props;
    const { enableEditing } = this.state;

    return (
      <Col sm={12} className="animated fadeIn">
        <Form onSubmit={handleSubmit((values) => this.handleSaveChanges(values))}>
          {enableEditing ? (
            <div className="animated fadeIn meta-info-form">
              <Row className="margin-bottom">
                <Field
                  labelSize={2}
                  label={'Meta title:'}
                  name={`${fieldKey}.data.attributes.sections.metaTitle`}
                  component={HorizontalFormControl}
                />
              </Row>
              <FormGroup controlId="meta-description">
                <Row>
                  <Col sm={2}>
                    <ControlLabel>Meta Description:</ControlLabel>
                  </Col>
                  <Col sm={10}>
                    <Field
                      component={TextArea}
                      name={`${fieldKey}.data.attributes.sections.metaDescription`}
                    />
                  </Col>
                </Row>
              </FormGroup>
              <Row>
                <Col sm={12}>
                  <Button bsStyle="default" handleClick={this.handleCancelEditing}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    bsStyle="primary"
                    className="pull-right"
                    isLoading={this.state.saving}
                  >
                    Save Changes
                  </Button>
                </Col>
              </Row>
            </div>
          ) : (
            <div className="hoverable-info" onClick={this.handleEditDefinition}>
              <Row>
                <Col sm={12}>
                  <Field
                    labelSize={3}
                    label={'Meta title:'}
                    component={InfoLabel}
                    name={`${fieldKey}.data.attributes.sections.metaTitle`}
                  />
                </Col>
                <Col sm={12}>
                  <Field
                    labelSize={3}
                    component={InfoLabel}
                    label={'Meta description:'}
                    name={`${fieldKey}.data.attributes.sections.metaDescription`}
                  />
                </Col>
              </Row>
            </div>
          )}
        </Form>
      </Col>
    );
  };

  render() {
    const { item } = this.props;
    const { showField } = this.state;
    return (
      <div className="meta-fields-container">
        <Row>
          <Col sm={12} onClick={this.toggleShowField}>
            <div className={`toggle-meta-info-btn ${showField && 'active'}`}>
              {item.attributes.name}{' '}
              <div className="pull-right">
                <Icon name={showField ? 'minus-circle' : 'plus-circle'} />
              </div>
            </div>
          </Col>
          {showField && this.renderFields()}
        </Row>
      </div>
    );
  }
}

export default flow([
  reduxForm({
    form: 'MetaInformationForm',
  }),
  connect(
    () => {
      return {
        destroyOnUnmount: false,
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
    }),
  ),
])(MetaInfoItem);
